import {
    useStyles,
    Caption,
    Checkbox,
    pxToRem,
    useTheme,
} from '@archipro-design/aria';

import * as S from './FilterContainer.mobile.style';
import type { ElasticSearchSortOptions } from '~/modules/search';
import type { SortOption } from '~/modules/search/hook/use-search-sorts';

export interface FilterSortByProps {
    sortOptions: SortOption[];
    onSortChange: (sort: ElasticSearchSortOptions) => void;
}

const FilterSortBy = ({ sortOptions, onSortChange }: FilterSortByProps) => {
    const theme = useTheme();
    const { css } = useStyles();

    return (
        <div className={css(S.SortByContainer)}>
            <Caption variant="03" className="sort-by-title">
                {`SORT BY`}
            </Caption>
            {sortOptions.map((s) => {
                return (
                    <Checkbox
                        key={s.value}
                        checked={s.selected}
                        onChange={() => onSortChange(s.value)}
                        indicator={{
                            kind: 'radio',
                            indicator: {
                                variables: {
                                    border: `1px solid ${theme.siteVariables.colors.charcoal[250]}`,
                                    size: pxToRem(14),
                                    checkedBackgroundColor:
                                        theme.siteVariables.colors
                                            .charcoal[250],
                                },
                            },
                        }}
                        label={{
                            children: s.name,
                            variables: {
                                fontSize: pxToRem(16),
                                letterSpacing: 'normal',
                            },
                        }}
                        variables={{
                            labelLineHeight: pxToRem(40),
                            radioIndicatorLabelGap: pxToRem(6),
                            radioIndicatorLabelCheckedGap: pxToRem(6),
                        }}
                    />
                );
            })}
        </div>
    );
};

export default FilterSortBy;
